$(document).ready(function () {
	$('.input-range input[type=range]').on('input', function () {
		let $c = $(this).closest('.input-range');
		$c.find('.numerator').val($(this).val());
	});
	$('.input-range .numerator').on('input', function () {
		let $c = $(this).closest('.input-range');
		$c.find('input[type=range]').val($(this).val());
	});
});